module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/2-e92d2c38d958319c89d88b3b0e47acd2.jpg";